module.exports = __webpack_public_path__ + "img/RestrictedIntelligence.29986ef9.jpg";